import { useEffect, useState } from 'react';
import { BehaviorSubject, Subject } from 'rxjs';
import { container } from 'tsyringe';
import { ILanguageService } from '../features/i18n/model/interfaces';

export function getEnv(varName: string): string | undefined {
  // const varFromWindow = ((window as any)[varName] || '').trim();
  // const isVarFromWindowEmpty =
  //   varFromWindow.startsWith('${') || varFromWindow === '';
  // return isVarFromWindowEmpty ? process.env[varName] : varFromWindow;
  return process.env[varName];
}

export function getRequiredEnv(varName: string): string {
  const val = getEnv(varName);
  if (val === undefined) {
    throw new Error(`${varName} is not defined`);
  }
  return val;
}

export const t = function (stringId: string, ...additionalArguments: any[]): string {
  const languageService: ILanguageService = container.resolve('languageService');
  return languageService.translate(stringId, ...additionalArguments);
};

export function useSubject<T>(subject: Subject<T>, initial?: T): T | undefined {
  const [stateValue, setStateValue] = useState<T | undefined>(initial);
  useEffect(() => {
    const listener = subject.subscribe(setStateValue);
    return () => listener.unsubscribe();
  }, [subject]);
  return stateValue;
}

export function useBehaviorSubject<T>(behaviorSubject: BehaviorSubject<T>): T {
  const [stateValue, setStateValue] = useState<T>(behaviorSubject.value);
  useEffect(() => {
    const listener = behaviorSubject.subscribe(setStateValue);
    return () => listener.unsubscribe();
  }, [behaviorSubject]);
  return stateValue;
}

export function importAll(r: any): Array<any> {
  return r.keys().map(r);
}
